module.exports = __webpack_public_path__ + "static/media/arb.02daa5ad.svg";